export default __webpack_public_path__ + "media/images/logo-symbol-wordmark-49e55f753e9c881dde563372ab1aa213.svg";